import { render, staticRenderFns } from "./SwiperSpecialistTeamCard.vue?vue&type=template&id=10ae7fd8&scoped=true&lang=pug&"
import script from "./SwiperSpecialistTeamCard.vue?vue&type=script&lang=js&"
export * from "./SwiperSpecialistTeamCard.vue?vue&type=script&lang=js&"
import style0 from "./SwiperSpecialistTeamCard.vue?vue&type=style&index=0&id=10ae7fd8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ae7fd8",
  null
  
)

export default component.exports